var FavoriteItem = /** @class */ (function () {
    function FavoriteItem(favoritePair) {
        if (favoritePair === void 0) { favoritePair = ""; }
        var pairs = favoritePair.split(";");
        if (pairs.length === 2) {
            this.setValues(pairs[0], pairs[1]);
        }
    }
    FavoriteItem.prototype.setValues = function (sportId, eventId) {
        this.sportId = sportId;
        this.eventId = eventId;
    };
    FavoriteItem.prototype.stringify = function () {
        return this.sportId && this.eventId ? this.sportId + ";" + this.eventId : "";
    };
    return FavoriteItem;
}());
export { FavoriteItem };
//# sourceMappingURL=FavoriteItem.js.map